























import { Component, Prop, Mixins } from "vue-property-decorator";
import { isEmail } from "@/utils/regex";

// Mixins
import {
  WidgetMixin,
  IdMixin,
  FieldMixin,
  GroupMixin,
  InputMixin,
  Validator,
} from "./mixins";
import AutoMixin from "@/mixins/auto";

@Component
export default class WEmail extends Mixins(
  Mixins(WidgetMixin, IdMixin, FieldMixin),
  AutoMixin,
  GroupMixin,
  InputMixin
) {
  created() {
    this.labelId = this.uniqueId("__W_EMAIL_");
  }

  @Validator("email", true)
  emailValidator(value: string) {
    return value ? isEmail(value) : true;
  }

  @Validator("required")
  requiredValidator(value: any) {
    return !!value;
  }
}
